import styled from 'styled-components';

import { flexCenter, flexStart, scrollCss } from '../../style/reusableStyle';

export const ScheduleCalenderContinerStyled = styled.div`
  margin-top: 30px;
  background: ${({ theme }) => theme.colors.lightBackground};
`;

export const DatesWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  max-width: 920px;
  gap: 5px;
  width: 100%;
  overflow-x: auto;
  ${scrollCss};

  &::-webkit-scrollbar {
    height: 0px;
  }
`;

export const IndividualDateStyled = styled.div`
  ${flexCenter(0)};
  flex-shrink: 0;
  height: 35px;
  width: 35px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.lighterBackground};
  }

  &.selected {
    background: ${({ theme }) => theme.colors.disableText};
  }

  & svg.btn-icon {
    &.left {
      transform: rotate(180deg);
    }

    & .right {
    }
  }
`;

export const ScheduleTagContainerStyled = styled.div`
  padding: 30px 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 40px 80px;
  justify-content: space-betwen;

  & .schedule-tag:nth-child(2n) {
    margin-left: 80px;
  }

  & .schedule-tag:nth-child(3n) {
    margin-left: 100px;
  }
  & .schedule-tag:nth-child(5n) {
    margin-left: 150px;
  }
  & .schedule-tag:nth-child(7n) {
    margin-left: 300px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    & .schedule-tag:nth-child(2n) {
      margin-left: 0px;
    }

    & .schedule-tag:nth-child(3n) {
      margin-left: 0px;
    }
    & .schedule-tag:nth-child(5n) {
      margin-left: 0px;
    }
    & .schedule-tag:nth-child(7n) {
      margin-left: 0px;
    }
  }
`;

export const DatesWithButtonWrapperStyled = styled.div`
  ${flexStart};
  gap: 6px;
  padding: 4px 10px;
`;
